// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"188":"3a687755","210":"7de29c8b","398":"31d6cfe0","438":"cee6186a","488":"d19e07ce"}[chunkId] + ".chunk.css";
};